module.exports = __webpack_public_path__ + "img/star-struck.34601d17.png";